<template>
  <b-modal header-close-content="" body-class="view-options-modal" id="view-options-modal" :title="$t('menubar.view')" ok-only data-cy="view-options-modal">
    <div class="section-wrapper">
      <div class="settings-group">
        <div class="mb-1">
          <div class="settings-group-title">{{ $t("menubar.general") }}</div>
        </div>
        <div class="d-flex align-items-center">
          <b-form-checkbox v-model="settings.IsUidVisible" switch data-cy="catalog-node-and-attribute-id-switch">{{
            $t("CatalogNodeAndAttributeIds")
          }}</b-form-checkbox>
        </div>
        <div class="d-flex align-items-center">
          <b-form-checkbox v-model="settings.IsCatalogNodeStatusVisible" switch data-cy="catalog-node-status">{{
            $t("menubar.options.showCatalogueGroupStatus")
          }}</b-form-checkbox>
        </div>
      </div>
      <div class="settings-group">
        <div class="mb-1">
          <div class="settings-group-title">
            {{ $t("menubar.targetCatalogue") }}
          </div>
        </div>
        <div class="d-flex align-items-center">
          <b-form-checkbox v-model="settings.ShowCatalogGroupArea" switch data-cy="catalog-group-details-switch">
            {{ $t("channelCreator.showCatalogGroupArea") }}
          </b-form-checkbox>
        </div>
        <div class="d-flex align-items-center">
          <b-form-checkbox v-model="settings.UsePredefinedNodeNames" switch data-cy="default-mapping-target-field-names-switch">
            {{ $t("channelCreator.UseDefaultTargetFieldNames") }}
          </b-form-checkbox>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  data() {
    return {
      checked: true,
      settings: {
        ShowCatalogGroupArea: false,
        UsePredefinedNodeNames: false,
        IsCatalogNodeStatusVisible: false,
        IsUidVisible: false
      }
    };
  },
  computed: {
    ...mapState(["userSettings"])
  },
  methods: {
    ...mapActions(["saveUserSettings"])
  },
  watch: {
    settings: {
      deep: true,
      handler(nv) {
        this.saveUserSettings(nv);
      }
    },
    userSettings: {
      immediate: true,
      deep: true,
      handler(nv) {
        if (!nv) return;

        Object.assign(this.settings, {
          ShowCatalogGroupArea: nv.ShowCatalogGroupArea === true || nv.ShowCatalogGroupArea === "true",
          UsePredefinedNodeNames: nv.UsePredefinedNodeNames === true || nv.UsePredefinedNodeNames === "true",
          IsCatalogNodeStatusVisible: nv.IsCatalogNodeStatusVisible === true || nv.IsCatalogNodeStatusVisible === "true",
          IsUidVisible: nv.IsUidVisible === true || nv.IsUidVisible === "true"
        });
      }
    }
  }
};
</script>
